import { SVGProps } from 'react';

const FunnelIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="41"
      height="38"
      viewBox="0 0 41 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.2">
        <path
          d="M1.41585 3.676C1.20765 3.44688 1.0704 3.16228 1.02073 2.8567C0.971058 2.55113 1.01111 2.23771 1.13601 1.95444C1.26092 1.67117 1.46533 1.43023 1.72445 1.26081C1.98356 1.0914 2.28627 1.0008 2.59585 1H37.7958C38.1058 1.00003 38.409 1.09007 38.6687 1.25918C38.9285 1.42829 39.1335 1.66919 39.2589 1.95261C39.3843 2.23604 39.4247 2.54978 39.3751 2.85572C39.3256 3.16166 39.1883 3.44663 38.9799 3.676L24.9959 18.6V30.33C24.996 30.5935 24.9311 30.8529 24.8069 31.0853C24.6827 31.3177 24.503 31.5158 24.2839 31.662L17.8839 35.928C17.6431 36.0886 17.3633 36.1809 17.0743 36.1951C16.7852 36.2093 16.4977 36.1448 16.2424 36.0086C15.9871 35.8723 15.7736 35.6693 15.6245 35.4213C15.4754 35.1732 15.3964 34.8894 15.3959 34.6V18.6L1.41585 3.676Z"
          fill="#0A0A0A"
        />
        <path
          d="M1.41585 3.676C1.20765 3.44688 1.0704 3.16228 1.02073 2.8567C0.971058 2.55113 1.01111 2.23771 1.13601 1.95444C1.26092 1.67117 1.46533 1.43023 1.72445 1.26081C1.98356 1.0914 2.28627 1.0008 2.59585 1H37.7958C38.1058 1.00003 38.409 1.09007 38.6687 1.25918C38.9285 1.42829 39.1335 1.66919 39.2589 1.95261C39.3843 2.23604 39.4247 2.54978 39.3751 2.85572C39.3256 3.16166 39.1883 3.44663 38.9799 3.676L24.9959 18.6V30.33C24.996 30.5935 24.9311 30.8529 24.8069 31.0853C24.6827 31.3177 24.503 31.5158 24.2839 31.662L17.8839 35.928C17.6431 36.0886 17.3633 36.1809 17.0743 36.1951C16.7852 36.2093 16.4977 36.1448 16.2424 36.0086C15.9871 35.8723 15.7736 35.6693 15.6245 35.4213C15.4754 35.1732 15.3964 34.8894 15.3959 34.6V18.6L1.41585 3.676Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M1.41585 3.676C1.20765 3.44688 1.0704 3.16228 1.02073 2.8567C0.971058 2.55113 1.01111 2.23771 1.13601 1.95444C1.26092 1.67117 1.46533 1.43023 1.72445 1.26081C1.98356 1.0914 2.28627 1.0008 2.59585 1H37.7958C38.1058 1.00003 38.409 1.09007 38.6687 1.25918C38.9285 1.42829 39.1335 1.66919 39.2589 1.95261C39.3843 2.23604 39.4247 2.54978 39.3751 2.85572C39.3256 3.16166 39.1883 3.44663 38.9799 3.676L24.9959 18.6V30.33C24.996 30.5935 24.9311 30.8529 24.8069 31.0853C24.6827 31.3177 24.503 31.5158 24.2839 31.662L17.8839 35.928C17.6431 36.0886 17.3633 36.1809 17.0743 36.1951C16.7852 36.2093 16.4977 36.1448 16.2424 36.0086C15.9871 35.8723 15.7736 35.6693 15.6245 35.4213C15.4754 35.1732 15.3964 34.8894 15.3959 34.6V18.6L1.41585 3.676Z"
          fill="url(#paint0_radial_3623_13338)"
          fillOpacity="0.3"
        />
      </g>
      <path
        d="M1.41585 3.676C1.20765 3.44688 1.0704 3.16228 1.02073 2.8567C0.971058 2.55113 1.01111 2.23771 1.13601 1.95444C1.26092 1.67117 1.46533 1.43023 1.72445 1.26081C1.98356 1.0914 2.28627 1.0008 2.59585 1H37.7959C38.1058 1.00003 38.409 1.09007 38.6687 1.25918C38.9285 1.42829 39.1335 1.66919 39.2589 1.95261C39.3843 2.23604 39.4247 2.54978 39.3751 2.85572C39.3256 3.16166 39.1883 3.44663 38.9798 3.676L24.9959 18.6V30.33C24.996 30.5935 24.9311 30.8529 24.8069 31.0853C24.6827 31.3177 24.503 31.5158 24.2839 31.662L17.8839 35.928C17.6431 36.0886 17.3633 36.1809 17.0743 36.1951C16.7852 36.2093 16.4977 36.1448 16.2424 36.0086C15.9871 35.8723 15.7736 35.6693 15.6245 35.4213C15.4754 35.1732 15.3964 34.8894 15.3959 34.6V18.6L1.41585 3.676Z"
        stroke="url(#paint1_linear_3623_13338)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3623_13338"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.198 0.999998) rotate(90) scale(35.197 28.7694)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_3623_13338"
          x1="20.198"
          y1="0.999999"
          x2="10.2968"
          y2="33.1475"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FunnelIcon;
